import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '../Modules/Shared/Services/auth.service';
import { SystemRole } from '../Enums/system-role.enum';
import { Operator } from '../Models/backoffice/operator.model';

@Injectable({
  providedIn: 'root',
})
export class OperatorFacade {
  private readonly _authService = inject(AuthService);

  readonly operator = toSignal<Operator | null>(this._authService.currentOperator$, {
    initialValue: null,
  });

  readonly systemRole = computed<SystemRole | null>(() => this.operator()?.system_role ?? null);

  readonly systemRoleLabelKey = computed<string>(() => this.operator()?.systemRoleLabelKey ?? '');

  readonly displayName = computed<string>(() => this.operator()?.name ?? '');

  readonly principalName = computed<string>(() => this.operator()?.userPrincipalName ?? '');

  readonly photo = computed<string | null>(() => this.operator()?.photo ?? null);

  atLeast(role: SystemRole): boolean {
    return this.operator()?.atLeast(role) ?? false;
  }
}
